// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"bottom-buttons__buttonsWrapper___H0sV4","back":"bottom-buttons__back___cHZMx"};